import { paths } from '@/routes/paths';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Stack justifyContent="center" alignItems="center" height="100vh" spacing={4}>
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Typography variant="h1" fontSize={24} borderRight="1px solid rgba(0,0,0,.3)" p={2}>
          404
        </Typography>

        <Typography variant="h2" fontSize={14} p={2}>
          Página não encontrada
        </Typography>
      </Stack>

      <Button color="inherit" onClick={() => navigate(paths.auth.signIn, { replace: true })}>
        ir para página inicial
      </Button>
    </Stack>
  );
}
